import styled from 'styled-components';

export const FormContainer = styled.div.attrs({
  className: 'form-container'
})``;
